const initialState={
	solicitudCompras:[],
	solicitudComprasByUser:[],
	solicitudCompraSelected:"",
	estadoSolicitudCompra:0	
};

export default function solicitudReducer(state= initialState,action){
	switch(action.type){
		case 'SOLICITUD_COMPRA':
     		return {...state,solicitudCompras:action.payload};
     	case 'SOLICITUD_COMPRA_USER':
     		return {...state,solicitudComprasByUser:action.payload};
     	case 'SOLICITUD_SELECTED':
     		return {...state,solicitudCompraSelected:action.payload};
     	case 'SOLICITUD_COMPRA_ESTADO':
     		return {...state,estadoSolicitudCompra:action.payload};
     	default:
     		return state
	}
}